import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Edit, Archive, ArchiveRestore, Phone, MapPin, User } from 'lucide-react';

const statusClass = (isActive) => isActive
  ? 'bg-[#2E4632]/10 text-[#2E4632] hover:bg-[#2E4632]/20'
  : 'bg-[#BC4749]/10 text-[#BC4749]';

export const WorkerCardList = ({ workers, searchTerm, fmt, onEdit, onArchive, onRestore }) => (
  <div className="md:hidden space-y-3" data-testid="workers-mobile-list">
    {workers.length === 0 ? (
      <Card className="bg-white border border-[#D1D1CD] rounded-lg">
        <CardContent className="p-6 text-center text-[#5C5C5C]">
          {searchTerm ? 'No workers found matching your search' : 'No workers added yet'}
        </CardContent>
      </Card>
    ) : (
      workers.map((worker) => (
        <Card
          key={worker.id}
          data-testid={`worker-card-${worker.id}`}
          className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm"
        >
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-full bg-[#2E4632] flex items-center justify-center flex-shrink-0">
                <User className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold text-[#1C1C1E] truncate">{worker.name}</p>
                    <div className="flex items-center gap-1.5 text-sm text-[#5C5C5C] mt-0.5">
                      <Phone className="w-3.5 h-3.5" />
                      <span className="truncate">{worker.phone}</span>
                    </div>
                  </div>
                  <Badge className={worker.archived ? 'bg-[#5C5C5C]/10 text-[#5C5C5C]' : statusClass(worker.is_active)}>
                    {(() => {
                      if (worker.archived) return 'Archived';
                      return worker.is_active ? 'Active' : 'Inactive';
                    })()}
                  </Badge>
                </div>
                <div className="mt-2 flex items-center gap-3 text-sm">
                  <span className="font-semibold text-[#2E4632]">
                    {fmt(worker.daily_wage)}
                    <span className="text-xs text-[#5C5C5C] font-normal">/day</span>
                  </span>
                </div>
                {worker.address && (
                  <div className="mt-1.5 flex items-start gap-1.5 text-xs text-[#5C5C5C]">
                    <MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                    <span className="line-clamp-2">{worker.address}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-3 pt-3 border-t border-[#D1D1CD]/60 flex justify-end gap-2">
              {worker.archived ? (
                <Button
                  variant="ghost"
                  size="sm"
                  data-testid={`restore-worker-mobile-${worker.id}`}
                  onClick={() => onRestore(worker.id)}
                  className="h-9 text-[#2E4632] hover:bg-[#2E4632]/10"
                >
                  <ArchiveRestore className="w-4 h-4 mr-1.5" /> Restore
                </Button>
              ) : (
                <>
                  <Button
                    variant="ghost"
                    size="sm"
                    data-testid={`edit-worker-mobile-${worker.id}`}
                    onClick={() => onEdit(worker)}
                    className="h-9 text-[#2E4632] hover:bg-[#2E4632]/10"
                  >
                    <Edit className="w-4 h-4 mr-1.5" /> Edit
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    data-testid={`archive-worker-mobile-${worker.id}`}
                    onClick={() => onArchive(worker.id)}
                    className="h-9 text-[#BC4749] hover:bg-[#BC4749]/10"
                  >
                    <Archive className="w-4 h-4 mr-1.5" /> Archive
                  </Button>
                </>
              )}
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
